import { FC } from "react";
import { Box, SxProps, Theme, Typography } from "@mui/material";

interface TopEarnerBadgeProps {
  rank: number;
  sx?: SxProps<Theme>;
}

const TopEarnerBadge: FC<TopEarnerBadgeProps> = ({ rank, sx }) => (
  <Box
    sx={[
      {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: "22px",
        px: "8px",
        py: "2px",
        borderRadius: "20px",
        backgroundColor: "#FFF2CC",
        border: "1px solid rgba(119, 91, 0, 0.15)",
        flexShrink: 0,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <Typography
      component="span"
      sx={{
        fontFamily: "Inter, sans-serif",
        fontWeight: 600,
        fontSize: "10px",
        lineHeight: "16px",
        color: "#775B00",
        whiteSpace: "nowrap",
      }}
    >
      🏆 Top {rank} Earners
    </Typography>
  </Box>
);

export default TopEarnerBadge;
